<template>
  <div
    :class="{
      'd-flex justify-content-center p-3 w-100': type === 'original',
      'd-flex justify-content-start text-secondary': type === 'small',
      'rounded border bg-light': isBordered && type === 'original'
    }"
  >
    <span>
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'EmptyListing',
  props: {
    title: {
      default: 'Нет данных для отображения',
      type: String
    },
    type: {
      default: 'original',
      type: String
    },
    isBordered: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
.type--small {
  background: none;
  border: none;
  text-align: left;
}
</style>
